// @flow

import React, { useRef, useCallback } from "react";
import { connect } from "react-redux";

import type { State, ReactRef } from "src/types";
import { setEmailData } from "src/actions/email";

import Editable from "react-contenteditable";

type Props = {
  value: string,
  setEmailData: Function,
};

function Message({ value, setEmailData }: Props) {
  const messageRef: ReactRef = useRef();

  const handleChange = (e) => {
    setEmailData({
      prop: "message",
      value: e.currentTarget.innerText,
    });
  };

  const handleKeyDown = useCallback((e) => {
    if (e.key === "Escape" || e.key === "Esc") {
      e.preventDefault();
      e.stopPropagation();
      messageRef.current.blur();
    } else if (e.key === "Enter") {
      document.execCommand("insertLineBreak");
      e.preventDefault();
    }
  }, []);

  const handlePaste = (e) => {
    e.preventDefault();
    const value = e.clipboardData.getData("text/plain");
    document.execCommand("insertText", false, value);
  };

  return (
    <Editable
      tagName="pre"
      innerRef={messageRef}
      disabled={false}
      html={value}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      onPaste={handlePaste}
      style={{
        width: "100%",
        margin: 0,
        flex: "auto",
        whiteSpace: "pre-wrap",
      }}
    />
  );
}

const mapStateToProps = ({ app }: State) => ({
  value: app.email.data.message,
});

const mapDispatchToProps = {
  setEmailData,
};

export default connect(mapStateToProps, mapDispatchToProps)(Message);
